export enum NodeType {
  Tag = 'tag',
  Symbol = 'symbol',
  Connection = 'connection',
}

/**
 * FS-621 — graph readiness reported by GET /v1/graph/:graphId/status, used by
 * the editor's poll-while-processing loop. See backend GraphStatusDto.
 */
export type GraphReadinessState = 'ready' | 'pending' | 'failed' | 'not_found'

export interface GraphStatus {
  state: GraphReadinessState
  error_message?: string
}

export enum ModeType {
  Select = 'select',
  Create = 'create',
  Drag = 'drag',
}

export interface Property {
  id: string
  target_id: string
  is_node_property: boolean
  key: string
  value: string
  confidence?: number
}

export interface Edge {
  id: string
  from_node: string
  to_node: string
}

export interface GraphData {
  id: string
  nodes: Set<string>
  edges: Record<string, Edge>
  properties: Record<string, Property>
  // `source` (VISN-343) nests an object here, so values are not all strings.
  document_info?: Record<string, unknown>
}
